import { ReactComponent as HomeIcon } from "assets/icons/home.svg";
import { ReactComponent as MyAccountIcon } from "assets/icons/my-account.svg";
import { ReactComponent as CausesIcon } from "assets/icons/causes.svg";
import { ReactComponent as NewsIcon } from "assets/icons/news.svg";
import { ReactComponent as PartnersIcon } from "assets/icons/partners.svg";
import { ReactComponent as EventIcon } from "assets/icons/events.svg";
import { ReactComponent as SuggestIcon } from "assets/icons/suggest.svg";
import { ReactComponent as ShopIcon } from "assets/icons/shop.svg";
import { ReactComponent as DonateIcon } from "assets/icons/donate.svg";

export const menus = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: <HomeIcon />,
  },
  {
    title: "My Account",
    icon: <MyAccountIcon />,
    submenus: [
      {
        title: "Settings",
        path: "/settings",
      },
      {
        title: "Order History",
        path: "/order-history",
      },
      {
        title: "Donation Receipts",
        path: "/donation-receipts",
      },
      {
        title: "Subscriptions",
        path: "/subscription/current-subscriptions",
      },
    ],
  },
  {
    title: "Causes",
    path: "/causes",
    icon: <CausesIcon />,
  },
  {
    title: "News",
    path: "/news",
    icon: <NewsIcon />,
  },
  {
    title: "Partners",
    path: "/partners",
    icon: <PartnersIcon />,
  },
  {
    title: "Events",
    path: "/events",
    icon: <EventIcon />,
  },
  {
    title: "Suggest",
    path: "/suggest",
    icon: <SuggestIcon />,
  },
  {
    title: "Shop",
    path: "/shop/home",
    icon: <ShopIcon />,
  },
  {
    title: "Donate",
    path: "/donate/1",
    icon: <DonateIcon />,
  },
];

export const menusOnFraud = [
  {
    title: "Verification",
    basepath: "/verification",
    path: "/verification",
  },
];

export const menusOnTax = [
  {
    title: "Upload Tax Form",
    basepath: "/tax-form",
    path: "/tax-form",
  },
];

export const mobileMenus = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: <HomeIcon />,
  },
  {
    title: "My Account",
    icon: <MyAccountIcon />,
    submenus: [
      {
        title: "Settings",
        path: "/settings",
      },
      {
        title: "Order History",
        path: "/order-history",
      },
      {
        title: "Donation Receipts",
        path: "/donation-receipts",
      },
      {
        title: "Subscriptions",
        path: "/subscription/current-subscriptions",
      },
    ],
  },
  {
    title: "Causes",
    path: "/causes",
    icon: <CausesIcon />,
  },
  {
    title: "News",
    path: "/news",
    icon: <NewsIcon />,
  },
  {
    title: "Partners",
    path: "/partners",
    icon: <PartnersIcon />,
  },
  {
    title: "Events",
    path: "/events",
    icon: <EventIcon />,
  },
  {
    title: "Suggest",
    path: "/suggest",
    icon: <SuggestIcon />,
  },
  {
    title: "Shop",
    path: "/shop/home",
    icon: <ShopIcon />,
  },
  {
    title: "Donate",
    path: "/donate/1",
    icon: <DonateIcon />,
  },
];

export const mobileMenusOnFraud = [
  {
    title: "Verification",
    path: "/verification",
  },
  {
    title: "Logout",
    path: "/logout",
  },
];

export const mobileMenusOnTax = [
  {
    title: "Upload Tax Form",
    path: "/tax-form",
  },
  {
    title: "Logout",
    path: "/logout",
  },
];

const submenuGroups = {
  subscription: [
    {
      title: "Current Subscriptions",
      path: "/subscription/current-subscriptions",
    },
    {
      title: "Past Subscriptions",
      path: "/subscription/past-subscriptions",
    },
  ],
};

export const getSubmenuGroups = (basepath) => {
  let submenus = [];
  Object.keys(submenuGroups)
    .filter((key) => key == basepath)
    .map((key) => {
      submenus = submenuGroups[key];
    });
  return submenus;
};
